import http from 'api';
import _logger from 'utils/logger';
import { message } from 'antd';
import { formatReceived, formatSent } from 'utils/formatters';

export const baseURI = 'empresas/actividades-economicas-de-contribuyentes/';

/**
 * GET Actividades Economicas de Contribuyentes
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getActividadesEconomicasDeContribuyente = async (params = null) => {
  try {
    const response = await http.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    _logger(err);
    return [];
  }
};

/**
 * GET Actividad Economica de Contribuyente
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getActividadEconomicaDeContribuyente = async (id) => {
  try {
    const response = await http.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    _logger(err);
    return null;
  }
};

/**
 * POST Actividad de Contribuyente
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postActividadEconomicaDeContribuyente = async (values) => {
  try {
    const response = await http.post(baseURI, formatSent(values));
    message.success(response?.detail || 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    _logger(err);
    return false;
  }
};

/**
 * PATCH Actividad de Contribuyente
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchActividadEconomicaDeContribuyente = async (id, values) => {
  try {
    const response = await http.patch(`${baseURI}${id}`, formatSent(values));
    message.success(response?.detail || 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    _logger(err);
    return false;
  }
};
/**
 * DELETE Actividad de Contribuyente
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteActividadEconomicaDeContribuyente = async (id) => {
  try {
    const response = await http.delete(`${baseURI}${id}/`);
    message.success(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    _logger(err);
    return false;
  }
};
